import { define, DepInjMixin } from '../Dependency';
import { Service } from './Service';
export class BaseService extends DepInjMixin(Service) {
    static serviceName = '';
    static define() {
        const serviceName = this.serviceName || this.name;
        if (!Service.locate(serviceName)) {
            new this();
        }
        define(serviceName, () => Service.locate(serviceName));
    }
}
//# sourceMappingURL=ServiceBase.js.map